import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL PROMO
export const getAllPromo = createAsyncThunk('promo/getAllPromo', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/promotions?limit=10&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// GET PROMO DETAIL BY ID
export const getDetailPromo = createAsyncThunk('promo/getDetailPromo', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/promotions/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// CREATE PROMO
export const createPromo = createAsyncThunk('promo/createPromo', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/admin/promotions`,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// DELETE PROMO
export const deletePromo = createAsyncThunk('promo/deletePromo', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/admin/promotions/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPDATE PROMO
export const updatePromo = createAsyncThunk('promo/updatePromo', async (payload, thunkAPI) => {
  const { payloadData, promoId } = payload;

  try {
    const response = await axiosInstance.put(
      `/admin/promotions/${promoId}`,
      { ...payloadData },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPLOAD IMAGE
export const uploadImagePromo = createAsyncThunk('promo/uploadImagePromo', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/admin/promotions/upload`,
      { file: payload },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    const data = await response.data;
    return data.file;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
